import { render, staticRenderFns } from "./FeedbackDialog.vue?vue&type=template&id=5b7ccac2"
import script from "./FeedbackDialog.vue?vue&type=script&lang=ts"
export * from "./FeedbackDialog.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackDialog.vue?vue&type=style&index=0&id=5b7ccac2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports